import { focusElement, findFirstContentElement } from "~/utils";

if (process.client) {
    if ("scrollRestoration" in window.history) {
        // reset scrollRestoration to auto when leaving page, allowing page reload
        // and back-navigation from other pages to use the browser to restore the
        // scrolling position.
        window.addEventListener("beforeunload", () => {
            window.history.scrollRestoration = "auto";
        });

        // Setting scrollRestoration to manual again when returning to this page.
        window.addEventListener("load", () => {
            window.setTimeout(() => {
                window.history.scrollRestoration = "manual";
            }, 300);
        });
    }
}

export default function (to, from, savedPosition) {
    let position = false;
    const isRouteChanged = to !== from;

    // savedPosition is only available for popstate navigations (back button)
    if (savedPosition) {
        position = savedPosition;
    } else if (isRouteChanged) {
        position = { x: 0, y: 0 };
    }

    if (!isRouteChanged || (to.path === from.path && to.hash !== from.hash)) {
        window.$nuxt.$nextTick(() => window.$nuxt.$emit("triggerScroll"));
    }

    return new Promise((resolve) => {
        // wait for the out transition to complete (if necessary)
        window.$nuxt.$once("triggerScroll", () => {
            // coords will be used if no selector is provided,
            // or if the selector didn't match any element.
            if (to.hash) {
                let hash = to.hash.substr(1);

                // CSS.escape() is not supported with IE and Edge.
                if (typeof window.CSS !== "undefined" && typeof window.CSS.escape !== "undefined") {
                    hash = window.CSS.escape(hash);
                }
                try {
                    // Can't use `#xyz` here as querySelector doesn't support IDs with leading numbers
                    // Also can't use getElementById as Nuxt requires a CSS selector
                    if (document.querySelector(`[id='${hash}']`)) {
                        // scroll to anchor by returning the selector
                        position = { selector: `[id='${hash}']` };

                        // Move focus to nearest element
                        window.$nuxt.$nextTick(() => {
                            let firstElm = findFirstContentElement(document.querySelector(`[id='${hash}']`));
                            focusElement(firstElm);
                        });
                    }
                } catch (e) {
                    console.warn("Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).");
                }
            } else {
                window.$nuxt.$nextTick(() => {
                    document.querySelector("#page-top")?.focus();
                    document.activeElement?.blur();
                });
            }

            resolve(position);
        });
    });
}
